import { DEV, ENV, GTM_ID, LOCAL, PROD } from './Config'

/** 
* Initialize Google Tag Manager (GTM) with the GTM ID read from GTM_ID.
* This initialization is performed only when the current environment equals LOCAL or DEV [ATM. Once validated in DEV env, will allow for PROD as well].
* @function initializeGTM
* @returns {void} No return value.
*/
export const initializeGTM = () => {
    if (ENV === PROD || ENV === LOCAL || ENV === DEV) {

        // --- HEAD SCRIPT (main GTM script) ---
        const nonce = document.querySelector('script[nonce]')?.nonce
        const gtmScript = document.createElement('script')
        gtmScript.id = "gtm-script"
        gtmScript.nonce = nonce  // attach the same nonce here

        gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');`
        document.head.appendChild(gtmScript)

        // --- BODY SCRIPT (noscript fallback) ---
        const noscript = document.createElement('noscript')
        noscript.id = "gtm-noscript"
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`
        // document.body.appendChild(noscript)
        document.body.insertBefore(noscript, document.body.firstChild)
    }
}

/**
 * Remove GTM artifacts from the page and clear related globals.
 * @function removeGTM
 * @returns {void} No return value.
 */
export const removeGTM = () => {
    const gtmScript = document.getElementById("gtm-script")
    const gtmNoscript = document.getElementById("gtm-noscript")

    gtmScript?.remove() // Remove script
    gtmNoscript?.remove() // Remove noscript iframe

    // Clear GTM data from memory
    delete window.dataLayer
    delete window.google_tag_manager
}

/**
 * Send a GTM event via the data layer.
 * Pushes the provided payload to the GTM dataLayer.
 * @param {Object} tagManagerArgs - The data layer payload to send (typically contains an "event" property and any associated data).
 * @returns {void} No return value.
 */
export const sendGTMEvent = (tagManagerArgs) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(tagManagerArgs)
}
